import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';

export default function AuthPromptModal({ open, onClose, message }) {
  const navigate = useNavigate();
  if (!open) return null;
  
  return createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ width: 420, background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <h3 style={{ marginTop: 0 }}>Account required</h3>
        <p style={{ color: '#333' }}>{message || 'You need an account to perform this action.'}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <button onClick={onClose} style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}>Go back</button>
          <button onClick={() => { onClose(); navigate('/login'); }} style={{ padding: '8px 12px', borderRadius: 6, border: 'none', background: '#7a9c3a', color: '#fff', cursor: 'pointer' }}>Login</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
